<template>
  <router-link v-if="router && router.name" tag="li" :to="router" :class="getClasses">
    <a href="#">
      <i :class="icon" /> <span>{{ name }}</span>
      <span v-if="badge && badge.name === router.name && badge.data" class="pull-right-container">
        <small class="label pull-right" :class="[badge.type==='String'?'bg-red':'label-primary']">{{ badge.data }}</small>
      </span>
    </a>
  </router-link>
  <li v-else :class="getClasses">
    {{ isHeader ? name : '' }}
    <a v-if="!isHeader" href="#">
      <i :class="icon" /> <span style="border: 2px solid transparent">{{ name }}</span>
      <span class="pull-right-container">
        <small v-if="badge && badge.name === router.name && badge.data" class="label pull-right" :class="[badge.type==='String'?'bg-green':'label-primary']">{{ badge.data }}</small>
        <i v-else class="fa fa-angle-left pull-right" />
      </span>
    </a>
    <ul v-if="items.length > 0" class="treeview-menu">
      <router-link v-for="(item,index) in items" :key="index" tag="li" :data="item" :to="item.router" :class="{ active: isSubItemActive(item.name) }">
        <a>
          <i :class="item.icon" /> {{ item.name }}
        </a>
      </router-link>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'SlideItem',
  props: {
    type: {
      type: String,
      default: 'item'
    },
    isHeader: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default() {
        return {}
      }
    },
    items: {
      type: Array,
      default() {
        return []
      }
    },
    router: {
      type: Object,
      default() {
        return {
          name: ''
        }
      }
    },
    link: {
      type: String,
      default: ''
    }
  },
  computed: {
    actived() {
      return this.$store.state.app.currentMenu === this.name ||
              this.items.filter(i => i.name === this.$store.state.app.currentMenu).length > 0
    },
    getClasses() {
      return {
        'active': this.actived,
        'header': this.isHeader,
        'treeview': !this.isHeader && this.type === 'tree'
      }
    }
  },
  created() {
  },
  filter: {
    isRouter(item) {
      return item.router && item.router.name
    }
  },
  methods: {
    isSubItemActive(name) {
      return this.$store.state.app.currentMenu === name
    }
  }
}
</script>
